var map = {
	"./calendario.svg": 1246,
	"./card.png": 1247,
	"./recargas.svg": 1248,
	"./repeat.svg": 1249,
	"./thumbs-up.svg": 1250,
	"./vantagens.svg": 1251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1245;